export default "__VITE_ASSET__CWYGZ_l3__"